import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import BalancesPage from '@pages/balances/BalancesPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

// const Shifts = lazy(() => import('@pages/Shifts').then((m) => ({ default: m.Shifts })));

// Route Component
const BalancesRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('balances-page-title')}>
        <BalancesPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  BalancesRoute,
};
